module.exports = __webpack_public_path__ + "static/media/a3_02.9788cbff.jpg";